module.exports = __webpack_public_path__ + "static/media/japan.f8dc0f04.svg";